// extracted by mini-css-extract-plugin
module.exports = {"input":"input-1tIvX"};